<header>
  <div class="container">
    <div class="d-flex flex-row justify-content-between">
      <a class="navbar-brand my-2" routerLink="/home" role="button" tabindex="0">
        <img src="assets/images/dspace-logo.svg" [attr.alt]="'menu.header.image.logo' | translate"/>
      </a>

      <div class="navbar navbar-light navbar-expand-md flex-shrink-0 px-0">
        <ds-search-navbar></ds-search-navbar>
        <div role="toolbar" [attr.aria-label]="'nav.user.description' | translate">
          <ds-lang-switch></ds-lang-switch>
          <ds-context-help-toggle></ds-context-help-toggle>
          <ds-auth-nav-menu></ds-auth-nav-menu>
          <ds-impersonate-navbar></ds-impersonate-navbar>
        </div>
        <div *ngIf="isMobile$ | async" class="pl-2">
          <button class="navbar-toggler px-0" type="button" (click)="toggleNavbar()"
                  aria-controls="collapsingNav"
                  aria-expanded="false" [attr.aria-label]="'nav.toggle' | translate">
            <span class="fas fa-bars fa-fw toggler-icon" aria-hidden="true"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</header>
